const AtomsText = (props) => {
    if (props.type === 'section-title') return <h1 className={'section-title '+props.class}>{props.text}</h1>
    if (props.type === 'section-sub-title') return <h1 className={'section-sub-title '+props.class}>{props.text}</h1>
    if (props.type === 'main-title') return <h1 className={props.class}>{props.text}</h1>
    if (props.type === 'title') return <h2 className={props.class}>{props.text}</h2>
    if (props.type === 'subtitle') return <h4 className={props.class}>{props.text}</h4>
    if (props.type === 'subtitle-second') return <h5 className={props.class}>{props.text}</h5>
    if (props.type === 'content') return <p className={props.class}>{props.text}</p>
    return null
}
  
export default AtomsText
